export const ReconTypeConstants = {
  UNABLE_TO_MATCH: '8EECEE29-4208-454F-B15C-0AFFE3968CA9',
  PARTIAL_MATCH: '98345990-238D-4297-93AE-0D4730536C7E',
  ALREADY_PAID: 'A1A638B0-B3CB-41F1-8F21-0F104A2D3EA9',
  AMOUNT_DOES_NOT_MATCH: '065F0913-8D29-4DEE-94F7-127AAC2D14F1',
  FULL_MATCH: '47FB9C03-4294-43B4-931C-237D6591B77E',
  MANUALLY_IGNORED: '507A7055-5157-4A88-B0C5-266C695E7672',
  DOUBLE_PAYMENT: '593002D6-F773-4B4F-B725-59207F90F07C',
  PAYMENT_LINK_MATCHED: 'F9137928-161B-4AEA-A6E5-94ED76133F86',
  AUTOMATICALLY_IGNORED: '0B32ECFF-8F8A-46C9-BEA2-C0A2A798683D',
  MANUALLY_MATCHED: 'C8CB5FF3-CA63-4F30-B554-C7DD08C90CBD',
  RENEWAL_NOT_GENERATED_YET: '3E687863-278B-4CC9-81D9-D356CAF8152D',
};
